ACC.categorySection = {
    _autoload: [
        ['init', $('[data-component=CategorySection]').length],
    ],

    init() {
        ACC.categorySection.start();
        $(window).smartresize(ACC.categorySection.start);
    },

    start() {
        const wrapper = $('[data-component=CategorySection]');
        const categoryList = wrapper.find('.category-section__list');
        // Get height list when item set in row direction
        const categoryListHeight = categoryList.height();
        const activeDirection = 'js-direction-column';

        if ($(window).width() > 767) {
            categoryList.addClass(activeDirection);
            categoryList.css('height', categoryListHeight);
        } else if (categoryList.hasClass(activeDirection)) {
            categoryList.removeClass(activeDirection);
            categoryList.removeAttr('style');
        }
    },
};
